<template>
  <v-col cols="12">
    <v-alert
      class="text-left"
      :class="uiComponentProperties.rounded ? 'rounded-b-pill rounded-t-pill' : ''"
      :text="uiComponentProperties.text"
      :value="true"
      v-if="error"
      type="error"
    >
      {{ error }}
    </v-alert>

    <v-text-field
      v-model="username"
      :label="$t('login.username')"
      :disabled="sent"
      autofocus
      :color="uiComponentProperties.inputColor"
      :rounded="uiComponentProperties.rounded && uiComponentProperties.outlined"
      :outlined="uiComponentProperties.outlined"
      hide-details
      class="mb-8"
      v-on:keyup.enter="submit"
    />

    <v-text-field
      v-model="code"
      v-if="sent"
      :label="$t('login.code')"
      :color="uiComponentProperties.inputColor"
      hide-details
      class="mb-8"
      :rounded="uiComponentProperties.rounded && uiComponentProperties.outlined"
      :outlined="uiComponentProperties.outlined"
    />

    <v-text-field
      v-model="password"
      v-if="sent"
      type="password"
      :label="$t('login.new_password')"
      :color="uiComponentProperties.inputColor"
      :rounded="uiComponentProperties.rounded && uiComponentProperties.outlined"
      :outlined="uiComponentProperties.outlined"
      hide-details
      class="mb-8"
      v-on:keyup.enter="verify"
    />

    <div class="text-center">
      <template v-if="sent">
        <v-btn
          :rounded="uiComponentProperties.rounded"
          class="font-weight-bold"
          block
          large
          :class="uiComponentProperties.buttonClass"
          :color="uiComponentProperties.buttonColor"
          @click="verify"
          :disabled="!username"
          :loading="loading"
        >
          <v-icon left>mdi mdi-send</v-icon>
          {{ $t('login.change_password') }}
        </v-btn>
        <v-btn
          :rounded="uiComponentProperties.rounded"
          small
          block
          :color="uiComponentProperties.buttonColor"
          class="mt-3 font-weight-regular"
          text
          @click="submit"
          :disabled="loading"
        >
          {{ $t('login.resend_code') }}
        </v-btn>
      </template>
      <template v-else>
        <v-btn
          :rounded="uiComponentProperties.rounded"
          class="font-weight-bold"
          block
          large
          :class="uiComponentProperties.buttonClass"
          :color="uiComponentProperties.buttonColor"
          @click="submit"
          :disabled="!username"
          :loading="loading"
        >
          <v-icon left>mdi mdi-send</v-icon>
          {{ $t('login.send_code') }}
        </v-btn>
      </template>
      <v-btn
        :rounded="uiComponentProperties.rounded"
        small
        block
        :color="uiComponentProperties.buttonColor"
        class="mt-3 font-weight-regular"
        text
        @click="signIn"
        :disabled="loading"
      >
        <v-icon left>mdi mdi-arrow-left</v-icon>
        {{ $t('login.back_to_sign_in') }}
      </v-btn>
    </div>
  </v-col>
</template>

<script>
import UiEventBus from '@/UiEventBus';
import CognitoService from '@/service/cognito.service';

export default {
  name: 'ForgotPassword',
  props: ['forgotPasswordConfig', 'uiComponentProperties'],
  data() {
    return {
      loading: false,
      username: '',
      code: '',
      password: '',
      error: '',
      sent: false,
    };
  },
  computed: {
    options() {
      const defaults = {
        header: this.$t('login.reset_password'),
      };
      return Object.assign(defaults, this.forgotPasswordConfig || {});
    },
  },
  methods: {
    async submit() {
      if (this.username.length === 0) return;

      this.loading = true;
      this.username = this.username.toLowerCase();
      try {
        await CognitoService.forgotPassword(this.username);
        this.setError(false);
        this.sent = true;
        console.log('forgotPassword success');
      } catch (e) {
        this.setError(e);
      }
      this.loading = false;
    },
    async verify() {
      this.loading = true;
      this.username = this.username.toLowerCase();
      try {
        await CognitoService.confirmPassword(this.username, this.code, this.password);
        this.setError('');
        console.log('forgotPasswordSubmit success');
        UiEventBus.$emit('authState', 'signIn');
      } catch (e) {
        this.setError(e);
      }
      this.loading = false;
    },
    signIn() {
      UiEventBus.$emit('authState', 'signIn');
    },
    setError(e) {
      if (!e) {
        this.error = '';
        return;
      }
      this.error = CognitoService.translate(e.message || e);
      console.error(this.error);
    },
  },
};
</script>
